import { createApp } from 'vue';
import App from './App.vue';
//import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router' 
import store from './store';
//import VueSidebarMenu from 'vue-sidebar-menu'
//import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Formatters from '@/utils/formatters'
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
//import '@fortawesome/fontawesome-free/css/all.min.css'

const app = createApp(App);
app.use(store)
app.use(router)
app.use(Toast, {
    position: POSITION.BOTTOM_RIGHT,
});
//app.provide('audio', audioService)
store.dispatch('auth/initializeStore').then(() => {
app.config.globalProperties.$formatters = Formatters;
    app.mount('#app');
});
